import { EMAIL_DELIVERY_LIST } from "../../../types";

const INITIAL_STATE = {
  mailDeliveryGetDetailsResponse: null,
  mailDeliveryGetDetailsResponseLoadinG: false,
};

export default function mailDeliveryStatusReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    //mailReferenceGetDetails
    case EMAIL_DELIVERY_LIST.EMAIL_DELIVERY_LIST_INIT:
      return {
        ...state,
        mailDeliveryGetDetailsResponseLoadinG: true,
      };
    case EMAIL_DELIVERY_LIST.EMAIL_DELIVERY_LIST_SUCCESS:
      return {
        ...state,
        mailDeliveryGetDetailsResponse: action.payload,
        mailDeliveryGetDetailsResponseLoadinG: false,
      };
    case EMAIL_DELIVERY_LIST.EMAIL_DELIVERY_LIST_FINISH:
      return {
        ...state,
        mailDeliveryGetDetailsResponseLoadinG: false,
      };

    default:
      return { ...state };
  }
}
